<template>
    <!-- 个人信息 -->
    <div style="padding:30px">
        <div class="my-title">
            个人信息
        </div>
        <!-- 表单 -->
        <el-form ref="form" :model="sizeForm" label-width="80px" size="mini">
            <el-form-item label="头像:">
                <el-upload
                    class="avatar-uploader"
                    action="https://app.comeandbuy.com.cn/addons/shopro/index/upload"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                >
                    <img v-if="avatar" :src="sizeForm.avatar" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
            </el-form-item>

            <el-form-item label="昵称:">
                <el-input v-model="sizeForm.nickname" class="el-inpu"></el-input>
            </el-form-item>
            <el-form-item label="生日:">
                <el-date-picker
                    v-model="sizeForm.birthday"
                    type="date"
                    placeholder="选择日期"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" class="pim_btn" @click="submitUserProfile">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
import { userProfile,shoproUser } from "@/api/index.js";
export default {
    data() {
        return {
            sizeForm: {
            avatar: "",
            birthday:'',
            nickname:'',
            },
            dialogImageUrl: "",
            dialogVisible: false,
            avatar: "",
            // birthday:'',

        };
    },
    created() {
        this.getUsers()
    },
    methods: {
        //图片上传
        handleAvatarSuccess(res, file) {
            if (res.code != 1) {
                return this.$message.error(res.msg);
            }
            this.avatar = res.data.full_url;
            this.sizeForm.avatar = res.data.full_url
        },
        beforeAvatarUpload() {},
        //提交个人信息
        submitUserProfile(){
        console.log(this.sizeForm);
        userProfile(this.sizeForm,header).then(res=>{
            console.log(res);
            if(res.code !== 1){
                return
            }
            this.$router.go(0);

        })
        },
        //获取个人信息
        getUsers(){
            shoproUser({},header).then(res=>{
                console.log(res);
                if(res.code !== 1){
                    return
                }
                this.avatar = res.data.avatar;
                this.sizeForm.avatar = res.data.avatar
                //  this.sizeForm.avatar = res.data.avatar
                 console.log(this.sizeForm.avatar);
                 this.sizeForm.nickname = res.data.nickname
                 this.sizeForm.birthday = res.data.birthday

            })
        }

    }
};
</script>
<style lang="less" scoped>
.my-title {
    font-size: 20px;
    padding: 0 10px;
    border-left: 5px solid #ff6701;
    margin-bottom: 10px;
    margin-left: -10px;
    line-height: 40px;
    font-weight: 400;
}
.el-upload--picture-card {
    width: 118px;
    height: 118px;
    line-height: 118px;
}

.el-inpu {
    width: 448px;
    height: 41px;
}
.el-radio.is-bordered {
    border: 0;
}
.pim_btn {
    width: 146px;
    height: 45px;
    margin-left: 375px;
    margin-top: 75px;
}

//
/deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/index/mine/components/pim.vue